/* eslint-env browser */

(function (window, document) {

  $(document).ready(function() {
    $('.search-form').on('submit', function(e) {
      e.preventDefault();

      var fn = $(e.target).find('input[name="fn"]').val() || ''
      var ln = $(e.target).find('input[name="ln"]').val() || ''
      var city = $(e.target).find('input[name="city"]').val() || '~'
      var state = $(e.target).find('select[name="state"]').val() || 'ALL'

      if (fn && ln) {
        // /la/searching/jack/~/doe/~/CA/~
        window.location = '/la/searching/' + fn + '/~/' + ln + '/' + city + '/' + state + '/~?tg_ref=peoplewhizblog'
      } else {
        window.location = '/la/?tg_ref=peoplewhizblog'
      }
    })
  });

})(window, document);
